import { USER_LIST, USER_DETAILS } from './../constant/ActionTypes';

export const userReducer = (state, action) => {
    switch (action.type) {
        case USER_LIST:
            return { ...state, userList: action.payload };
        case USER_DETAILS:
            return { ...state, userDetails: action.payload };
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./contexts/reducer/userReducer.js